import React, { useMemo, useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import SortBySelect from '@op/components/FilterBoxCommon/filters/single-select-factory';
import { NO_DATE } from '@op/constants';
import useLanguage from '@op/hooks/useLanguage';
import { barIcon, commonBarHIcon, lineIcon, pieIcon, stackLineIcon, SymbolType, tableIcon, vsIcon } from '@op/constants/chart';
import { goToCompetitorKeyMetrics } from '@op/utils/url';
import Table from './Table';
import { TABLE_HEADER_TYPE } from '../../constant';
import Chart from './Chart';
import PieChart from './PieChart';
import { IRealtimeCommunity } from '../../type';
import { downloadAction } from '@op/pages/download/utils';

const StreamCommunityChart = (props: IRealtimeCommunity) => {
  const { title, dropdown, filter, gameInfo, valueKey, chartData, loading } = props;
  const { formatMessage } = useLanguage();
  const [byType, setByType] = useState<string>(dropdown?.[0].value ?? '');
  const [chartType, setChartType] = useState<SymbolType>('stack_line');

  function changeChartType(type: any) {
    if (type === 'vs') {
      goToCompetitorKeyMetrics(history, filter, 'Community');
    } else {
      setChartType(type || 'bar');
    }
  }

  const isEmpty = useMemo(() => {
    const { listData } = chartData || {};
    const { topList } = listData || {};
    const totalList = topList?.find((val) => val.name === 'Total') || {};
    return !(totalList?.[valueKey] > 0);
  }, [chartData, valueKey]);
  const renderComponent = useMemo(() => {
    const { tableData, seriesData, listData, xAxisData: xAxis, legendData: legend } = chartData || {};
    const series = seriesData?.[valueKey] || [];
    const tableRecords = tableData?.map((val) => ({
      key: val.name,
      value: val?.[valueKey] || 0,
      ...val
    }));

    if (chartType === 'table') {
      return (
        <Table
          header={TABLE_HEADER_TYPE?.[byType] || ''}
          title={title}
          data={tableRecords || []}
          filter={filter}
        />
      );
    }

    if (chartType === 'pie' || chartType === 'common-bar') {
      const { topList } = listData || {};
      const totalList = topList?.find((val) => val.name === 'Total') || {};
      const pieData = topList?.filter((val) => val.name !== 'Total').map((val) => ({
        name: val.name,
        value: val?.[valueKey] || 0
      })) || [];

      return (
        <PieChart
          chartType={chartType}
          data={{
            xAxis,
            legend,
            pieData,
            pieTotalData: totalList?.[valueKey] || 0
          }}
          title={title}
          filter={filter}
          byType={byType}
          gameInfo={gameInfo}
        />
      );
    }
    return (
      <Chart
        chartType={chartType}
        data={{
          xAxis,
          legend,
          series
        }}
        title={title}
        filter={filter}
        byType={byType}
        gameInfo={gameInfo}
      />
    );
  }, [chartType, chartData]);


  return (
    <CardCommon
      title={
        <SortBySelect
          defaultValue={byType}
          onChange={(key: string, value: any) => {
            setByType(value);
          }}
          defaultParams={{
            options: dropdown,
            btnTextPrefix: formatMessage({ id: title || NO_DATE.EMPTY }),
            matchButtonWidth: true,

            // dealwithButton: (value: any, { textMap }: any) => {
            //   return textMap[value];
            // },
          }}
        />
      }
      operations={[
        vsIcon,
        pieIcon,
        tableIcon,
        lineIcon,
        stackLineIcon,
        commonBarHIcon,
        barIcon,
      ]}
      operationInfo={[chartType, changeChartType]}
      loading={loading}
      loadingHeight={366}
      emptyHeight={366}
      className='dbo-realtime-community-chart'
      contentCard
      hasDownload={chartData?.tableData}
      empty={isEmpty}
      handleDownloadOnClick={() => {
        const byTypeLabel = dropdown?.find((val) => val.value === byType)?.text;
        downloadAction({
          key: 'RealtimeOverviewMetricsDownload',
          fileName: `Realtime Community ${title} - ${byTypeLabel}`,
          filter: {
            ...filter,
            ...gameInfo,
          },
          auxiliaryParams: {
            columns: [
              {
                name: TABLE_HEADER_TYPE?.[byType] || '',
                value: 'name'
              }
              , {
                name: title,
                value: valueKey
              }]
          },
          data: chartData?.tableData
        });
      }}
    >
      <>
        {renderComponent}
      </>
    </CardCommon >
  );
};

export default StreamCommunityChart;